import {SearchField} from '../SearchField';
import {BalanceModal} from './BalanceModal';
import {debounce} from 'debounce';
import $ from "jquery";


require('../../../sass/components/CustomerBox/_menu.scss');


export const Menu = {
    name: 'Menu',
    components: {
        SearchField,
        BalanceModal
    },
    data: function () {
        return {
            search_parcel: '',
            open_balance_free_tax: false,
            open_menu: false,
            urls: {},
            balance_refresh: null,
            messages_count: 0,
            messages_count_interval_id: null
        }
    },
    props: {
        open_balance_free_tax: Boolean,
        _class: String,
        _email: String,
        _customer_id: Number,
        _balance: Number,
        _balance_free_tax: Number,
        _urls: {},
        only_free_tax: Boolean
    },
    mounted() {
        this.balance_refresh = debounce(this.getBalances.bind(this), 1000);

        // messages counter starting
        if (this.is_logged) {
            // document.addEventListener('visibilitychange', function (event) {
            //     if (document.hidden) {
            //         if (!!this.messages_count_interval_id) {
            //             clearInterval(this.messages_count_interval_id);
            //             this.messages_count_interval_id = null;
            //         }
            //     } else {
            //         this.messages_count_interval_id = this.getMessagesNewCountInterval();
            //     }
            // }.bind(this));

            this.getMessagesNewCount();

            // document.dispatchEvent(new Event('visibilitychange'));
        }
    },
    computed: {
        is_logged: function () {
            return this._email !== '';
        },
        is_messages_new() {
            return !!this.messages_count;
        },
    },
    watch: {
        open_menu() {
            if (this.open_menu) {
                document.body.classList.add('noscroll');
                this.balance_refresh();
            } else {
                document.body.classList.remove('noscroll');
            }
        }
    },
    methods: {
        submitSearchParcel() {
            location.href = '/sledzenie-przesylki/status/' + encodeURIComponent(this.search_parcel)
        },
        boxOpen() {
            this.open_balance_free_tax = true;
        },
        isMobile() {
            return window.matchMedia('(max-width: 1199px)').matches;
        },
        menuOpenOver() {
            if (!this.isMobile())
                this.open_menu = true;
        },
        menuOpenClick() {
            if (this.isMobile())
                this.open_menu = true;
        },
        menuCloseOver() {
            if (!this.isMobile())
                this.open_menu = false;
        },
        menuCloseClick() {
            if (this.isMobile())
                this.open_menu = false;
        },
        balanceModalOpen(free_tax) {
            this.open_menu = false;
            this.$refs.balanceModal.free_tax = free_tax;
            this.$refs.balanceModal.open();
        },
        getBalances() {
            // var _self = this;
            $.get('/ajax/get_user_menu_data').then(function (response) {
                let balance = (response.balance / 100).toFixed(2);
                let balance_free_tax = (response.balance_free_tax / 100).toFixed(2);
                this._balance = balance;
                this._balance_free_tax = balance_free_tax;
            }.bind(this));
        },
        getMessagesNewCount() {
            $.get('/ajax/customer/messages/new/count').then(function (result) {
                if(result.status === 1) {
                    if (this.messages_count < result.count) {
                        // console.log('InitEventInMenu');
                        document.dispatchEvent(new Event('messageReload'));
                    }
                    this.messages_count = result.count;
                } else {
                    // document.location.reload();
                }
            }.bind(this));
        },
        getMessagesNewCountInterval() {
            this.getMessagesNewCount();
            return setInterval(function() {
                this.getMessagesNewCount();
            }.bind(this), 15000);
        }
    },
    template: `
      <div>
      <div :class="{'container_menu--open': open_menu}"
           @mouseover="menuOpenOver"
           @mouseleave="menuCloseOver">
        <a :class="[_class, {'logged': is_logged}]" @click="menuOpenClick">
          <span class="name">{{ _email }}</span>
          <span class="message_news" v-if="is_messages_new"></span>
        </a>
        <div class="menu" :class="{'menu_open': open_menu}">
          
          <div class="menu__header">
            <div>
                <div class="menu__header--logo"></div>
                <div class="menu__header--close" @click="menuCloseClick"></div>
            </div>
          </div>
          
          <div class="menu__body">

            <form class="menu__search" @submit.prevent="submitSearchParcel" action="/" method="GET">
              <div is="SearchField" v-model="search_parcel" placeholder="Szukaj przesyłki"></div>
            </form>
            <ul class="menu__list boxes">
              <li class="menu__list__element container_box box_open"
                  v-if="is_logged"
                  @click="balanceModalOpen(false)">
                <span class="container_box__label">Saldo główne:</span>
                <span class="container_box__value">{{ _balance }}&nbsp;zł</span>
                <span class="container_box__add"></span>
                <span class="container_box__open"></span>
              </li>
              <li class="menu__list__element container_box"
                  v-if="is_logged"
                  :class="{'box_open': open_balance_free_tax}"
                  @click="open_balance_free_tax ? balanceModalOpen(true) : boxOpen()">
                <span class="container_box__label">Wysyłka poza&nbsp;EU:</span>
                <span class="container_box__value">{{ _balance_free_tax }}&nbsp;zł</span>
                <span class="container_box__add"></span>
                <span class="container_box__open"></span>
              </li>
            </ul>
            <ul class="menu__list links">
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_orders" class="menu__list__link">Zamówienia</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_invoices" class="menu__list__link">Faktury</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_cash_on_delivery" class="menu__list__link">Pobrania</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_address_book" class="menu__list__link">Książka adresowa</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.import_shipment" class="menu__list__link">Import przesyłek</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_templates" class="menu__list__link">Szablon przesyłek</a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_messages" class="menu__list__link">Wiadomości <span class="counter" id="messages_count" v-if="is_messages_new">{{ messages_count }}</span></a>
              </li>
              <li class="menu__list__element" v-if="is_logged">
                <a :href="_urls.show_personal_data" class="menu__list__link">Ustawienia</a>
              </li>

              <li class="menu__list__element" v-if="is_logged">
                <div class="menu__list__separator"></div>
              </li>

              <li class="menu__list__element" v-if="isMobile()">
                <a :href="_urls.show_index" class="menu__list__link">Wyceń przesyłkę</a>
              </li>
              <li class="menu__list__element">
                <a :href="_urls.show_order_form" class="menu__list__link">Zamów kuriera</a>
              </li>
              <li class="menu__list__element">
                <a :href="_urls.show_tracking_main" class="menu__list__link">Śledzenie przesyłki</a>
              </li>
              <li class="menu__list__element">
                <a :href="_urls.show_blog" class="menu__list__link" target="_blank">Blog</a>
              </li>
              <li class="menu__list__element">
                <a :href="_urls.show_pricing" class="menu__list__link">Cennik</a>
              </li>
              <li class="menu__list__element">
                <a :href="_urls.show_contact" class="menu__list__link">Kontakt</a>
              </li>
              
                <li class="menu__list__element fixed_action" v-if="!is_logged" style="">
                    <a :href="_urls.show_login">
                      <button class="button button--small button--danger button--tablet-full button--full">Logowanie</button>
                    </a>
                    <a :href="_urls.show_register">
                      <button class="button button--small button--primary button--tablet-full button--full">Rejestracja</button>
                    </a>
                </li>
      
              <li class="menu__list__element margin_top " v-if="is_logged">
                <a :href="_urls.process_logout">
                  <button class="button button--small button--primary button--tablet-full button--full">Wyloguj</button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <BalanceModal ref="balanceModal"
                    :url="_urls.create_payment"
                    :balance="_balance"
                    :balance_free_tax="_balance_free_tax"
                    :only_free_tax="only_free_tax"
      />
      </div>
    `
};
